import {
  Directive,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  Self,
  Optional
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[autoResizeTextarea]'
})
export class AutoResizeTextareaDirective implements OnInit {

  constructor(
    private ngZone: NgZone,
    private elementRef: ElementRef,
    @Self() @Optional() private ngModel: NgModel
  ) {}

  ngOnInit() {
    this.resize(); // Initial resize on component load

    if (this.ngModel) {
      // need to resize on initial set of ngModel value
      this.ngModel.control.valueChanges.subscribe(() => {
        this.resize();
      });
    }
  }

  @HostListener('input') // Listen for input events (user typing)
  onInput() {
    this.resize();
  }

  @HostListener('paste') // Listen for paste events
  onPaste() {
    this.resize();
  }

  private resize() {
    this.ngZone.runOutsideAngular(() => {
      const textarea = this.elementRef.nativeElement;
      textarea.style.height = 'auto'; // Reset height to recalculate scrollHeight accurately
      textarea.style.height = `${textarea.scrollHeight + 10}px`; // Set height based on content
    });
  }
}
